import { render, staticRenderFns } from "./assign-user-contact-widget.vue?vue&type=template&id=0a8a00f4&"
import script from "./assign-user-contact-widget.vue?vue&type=script&lang=js&"
export * from "./assign-user-contact-widget.vue?vue&type=script&lang=js&"
import style0 from "./assign-user-contact-widget.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports